<template>
    <div class="container btn-base">
        <router-link  :to="{ name: 'produkt_details', params: { produktID: item.id }}">
            <img :src="item.image" alt="">

            <div class="font-produkte">{{ item.name | maxLength}}</div>
            <div class="font-produkte">{{ item.performer }}</div>
        </router-link>
    </div>
</template>

<script>
  export default {
    props: ['item']
  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app';

    img {
        height: 157px;
        width: 157px;
    }

    .font-produkte {
        line-height: 100%;
    }

    .container {
        padding: 0;
        margin: 0;
        max-width: 157px;
        &:hover {
            box-shadow: 0 2px 8px 2px rgba(194,194,194,1) !important;
        }
    }
</style>
